import type { LiveStreamQuota, MemberSettings } from '@/models/interface/member';
import type { EliteActivityResult } from '@/models/interface/profile';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class MemberService extends ApiFactory {
  constructor() {
    super('Member');
  }

  /**
   * 取得會員課程時間戳（秒）
   * @remarks classTimestamps內會是時間戳秒數
   */
  getClassSchedule(): Promise<
    ApiDataResponse<{
      classTimestamps: number[];
    }>
  > {
    return super.get('ClassSchedule');
  }

  /**
   *  檢查是否有重複上課
   *
   * @param customer_id 固定411
   */
  checkRepeatClass(class_cname: string): Promise<ApiDataResponse<boolean>> {
    return super.get(`CheckRepeatClass?customer_id=411&class_cname=${class_cname}`);
  }

  /**
   *  檢查是否有重複上課
   *
   * @param customer_id 固定411
   */
  checkRepeatClassV2(class_id: string): Promise<ApiDataResponse<boolean>> {
    return super.get(`CheckRepeatClassV2?classId=${class_id}`);
  }

  /**
   *  檢查是否有展延過
   */
  isExtensionShow(): Promise<ApiDataResponse<boolean>> {
    return super.get('ExtensionShow');
  }

  /**
   *  送出展延
   */
  setExtensionShow(): Promise<ApiDataResponse<boolean>> {
    return super.postNoData('Extension');
  }

  /**
   * 取得會員平台功能設定
   * @returns
   */
  settings(): Promise<ApiDataResponse<MemberSettings>> {
    return super.get('Settings');
  }

  /**
   * 領取兩張上課券
   */
  withdrawTicket(): Promise<ApiDataResponse<boolean>> {
    return super.postNoData('WithdrawTicket');
  }

  /**
   * 累計觀看時間，到40分鐘時使用直播卷，如果未到回傳值則都是初始值
   */
  useLiveStreamTicket(sourceId: string): Promise<ApiDataResponse<LiveStreamQuota>> {
    return super.postNoData('UseLiveStreamTicket', undefined, {
      params: { sourceId },
      headers: { disableGlobalLoading: true }
    });
  }

  /**
   * 檢查直播券
   */
  checkLiveStreamTicket(sourceId: string): Promise<ApiDataResponse<LiveStreamQuota>> {
    return super.get('CheckTicket', { sourceId });
  }

  /**
   * 取得活動方案 (上市上櫃免費方案一年制 ad_id:4846)
   */
  getEliteActivity(): Promise<ApiDataResponse<EliteActivityResult[]>> {
    return super.get('ExtraPlan');
  }
}
